(ns teamoesterreich.user-mode.wana-help.neighbor.checks
  (:require [clojure.string]
            ))




(defn check-wanado? [!actual-user]
  (or
    (get-in @!actual-user [:help :NormNachbarschaftshilfe])
    (get-in @!actual-user [:help :KatNachbarschaftshilfe])
    )
  )

(defn check-profile? [!actual-user]
  true)

(defn check-all? [!actual-user]
  (and
    (check-profile? !actual-user)
    (check-wanado? !actual-user)
    )
  )







